import React, { useState } from 'react';
import { Button } from './ui/button';

const WhatsAppButton = () => {
  // Get WhatsApp number from environment variable
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '+917990090809';
  const message = encodeURIComponent(`Hi FIT-FRAME!
I just visited your website and I'm interested in knowing more about the Transformation Shoot.
Can you guide me on how to get started?`);
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <>
      {/* Floating WhatsApp Button - Simple & Professional */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
          aria-label="Contact on WhatsApp"
        >
          <div className="bg-[#25D366] hover:bg-[#128C7E] rounded-full w-14 h-14 flex items-center justify-center shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer">
            {/* Simplified WhatsApp Icon */}
            <svg 
              viewBox="0 0 24 24" 
              className="w-7 h-7"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            </svg>
          </div>
        </a>
      </div>
    </>
  );
};

export default WhatsAppButton;
